<script>
    import { onMount, onDestroy } from 'svelte';
    import {updateNotificationSettings} from "../lib/ApiRequests.svelte";
    import {_} from '../lib/i18n';

    export let locale;
    export let params = {};
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    let email;
    $: email = (params && params.identity) ? params.identity.email : null;

    export let identity = {};

    let isPremiumUser = true; //(identity && identity.spy_subscription && identity.spy_subscription.tariff.type === 'premium') ? true : false;

    let emailAnalyzeFinishedNotify = (identity.spy_email_analyze_finished_notify === true ? true : false);
    let telegramReportSend = (isPremiumUser && identity.spy_telegram_report_send === true ? true : false);
    let emailReportSend = (identity.spy_email_report_send === true ? true : false);

    let reportsFrequency = String(typeof identity.spy_reports_frequency !== 'undefined' ? identity.spy_reports_frequency : '7');

    let botPinCode = (typeof identity.spy_telegram_bot_pin !== 'undefined' ? identity.spy_telegram_bot_pin : '-');


    onMount(() => {
        //window.scrollTo(0, 0);

        try {
            if (params && params.setState instanceof Function) {
                params.setState({
                    pageTitle: $_('notificationSettings.pageTitle'),
                    pageTitleTag: $_('notificationSettings.pageTitleTag'),
                });
            }
        } catch (err) {
            console.error(err);
        }
    });

    onDestroy(() => {

    });

    let loading = false;
    async function saveSettings() {
        const response = await updateNotificationSettings(
            (emailAnalyzeFinishedNotify ? 1 : 0),
            (emailReportSend ? 1 : 0),
            (telegramReportSend ? 1 : 0),
            reportsFrequency
        );

        identity.changeKeyValue('spy_email_analyze_finished_notify', emailAnalyzeFinishedNotify);
        identity.changeKeyValue('spy_telegram_report_send', telegramReportSend);
        identity.changeKeyValue('spy_email_report_send', emailReportSend);
        identity.changeKeyValue('spy_reports_frequency', reportsFrequency);
    }


let showModal = false;

    function copyPinCode() {
        const iconCopy = document.querySelector('.notifications-telegram__copy-code .copy');
        const iconCopied = document.querySelector('.notifications-telegram__copy-code .copied');

        navigator.clipboard.writeText(botPinCode)
            .then(() => {
                iconCopy.style.display = "none";
                iconCopied.style.display = "block";
            });
    }
</script>

<div class="canvas__col canvas__col_left">
    <!-- Блок управления уведомлениями о готовности данных -->
    <section class="notification-data">
        <div class="notification-data__header">
            <h4 class="notification-data__title">{$_('notificationSettings.readyBlockTitle')}</h4>
            <div class="notification-data__toggle toggle-switch">
                <label class="switch">
                    <input bind:checked={emailAnalyzeFinishedNotify} type="checkbox" on:change={saveSettings} />
                    <span></span>
                </label>
            </div>
        </div>
        <p class="notification-data__text">
            {@html $_('notificationSettings.readyBlockDescription', {
                values: { email }
            })}
        </p>
    </section>
</div>

{#if locale === 'ru-RU'}
    <div class="canvas__col canvas__col_right">
        <!-- Блок управления уведомлениями Отчет о событиях -->
        <section class="notification-data">
            <div class="notification-data__header">
                <h4 class="notification-data__title">{$_('notificationSettings.reportsBlockTitle')}</h4>
            </div>
            <p class="notification-data__text">
                {$_('notificationSettings.reportsBlockDescription')}
            </p>
            <div class="notification-data__controls">
                <div class="notification-data__controls-item">
                    <div class="notification-data__controls-toggle toggle-switch">
                        <label class="switch">
                            <input type="checkbox" bind:checked={emailReportSend} on:change={saveSettings} />
                            <span></span>
                        </label>
                    </div>
                    <div class="notification-data__controls-title">{$_('notificationSettings.byMailLabel')}</div>
                </div>
                <div class="notification-data__controls-item">
                    <div class="notification-data__controls-toggle toggle-switch">
                        <label class="switch">
                            <input disabled={!isPremiumUser} type="checkbox" bind:checked={telegramReportSend} on:change={saveSettings} />
                            <span></span>
                        </label>
                    </div>
                    <div class="notification-data__controls-title">{$_('notificationSettings.byTelegramLabel')}</div>
                </div>
            </div>
            <div class="notification-data__period">
                <p class="notification-data__period-title">{$_('notificationSettings.reportsPeriodLabel')}</p>
                <div class="notification-data__period-select">
                    <select name="" class="general-input" bind:value={reportsFrequency} on:change={saveSettings} >
                        <option value="1">{$_('notificationSettings.everyDayLabel')}</option>
                        <option value="3">{$_('notificationSettings.everyThreeDaysLabel')}</option>
                        <option value="7">{$_('notificationSettings.everyWeekLabel')}</option>
                        <option value="30">{$_('notificationSettings.everyMonthLabel')}</option>
                    </select>
                </div>
            </div>
        </section>
        {#if !isPremiumUser}
        <section class="notifications-telegram">
            <div class="notifications-telegram__title-wrapper">
                <div class="notifications-telegram__title-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.6556 1.84136C16.5685 1.7661 16.4624 1.71605 16.3489 1.6966C16.2355 1.67714 16.1188 1.68903 16.0116 1.73096L1.76203 7.30745C1.56009 7.38598 1.38911 7.52798 1.27486 7.71209C1.1606 7.8962 1.10924 8.11244 1.12851 8.32826C1.14779 8.54408 1.23665 8.7478 1.38172 8.90874C1.52679 9.06969 1.72023 9.17915 1.93289 9.22065L5.625 9.94557V14.0624C5.62427 14.2866 5.69091 14.5059 5.81628 14.6918C5.94165 14.8777 6.11997 15.0217 6.32813 15.1051C6.53596 15.19 6.76453 15.2103 6.9841 15.1636C7.20367 15.1168 7.40409 15.005 7.5593 14.8428L9.33961 12.9964L12.1641 15.4686C12.3678 15.6494 12.6307 15.7494 12.903 15.7499C13.0224 15.7498 13.141 15.731 13.2546 15.6943C13.4402 15.6354 13.6071 15.529 13.7388 15.3855C13.8704 15.242 13.9621 15.0666 14.0048 14.8766L16.8588 2.46081C16.8844 2.34884 16.8789 2.23203 16.8431 2.1229C16.8073 2.01378 16.7425 1.91645 16.6556 1.84136ZM12.3567 4.37261L6.05742 8.88386L2.56992 8.19972L12.3567 4.37261ZM6.75 14.0624V10.7239L8.49305 12.2525L6.75 14.0624ZM12.9045 14.6249L7.09102 9.52722L15.4582 3.53026L12.9045 14.6249Z" fill="#1B62A4" />
                    </svg>
                </div>
                <h3 class="notifications-telegram__title-text">{$_('notificationSettings.telegramSettingsBlockTitle')}</h3>
            </div>
            <p class="notifications-telegram__text">{$_('notificationSettings.telegramOnlyForPremiumDisclaimer')}</p>
            <a href="/instashpion/main/premium-info" class="button button_textual notifications-telegram__controls-btn notifications-telegram__controls-btn_secondary">
                {$_('notificationSettings.aboutPremiumTariffLabel')}
            </a>
        </section>
        {/if}

        <section class="notifications-telegram">
            <div class="notifications-telegram__title-wrapper">
                <div class="notifications-telegram__title-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.6556 1.84136C16.5685 1.7661 16.4624 1.71605 16.3489 1.6966C16.2355 1.67714 16.1188 1.68903 16.0116 1.73096L1.76203 7.30745C1.56009 7.38598 1.38911 7.52798 1.27486 7.71209C1.1606 7.8962 1.10924 8.11244 1.12851 8.32826C1.14779 8.54408 1.23665 8.7478 1.38172 8.90874C1.52679 9.06969 1.72023 9.17915 1.93289 9.22065L5.625 9.94557V14.0624C5.62427 14.2866 5.69091 14.5059 5.81628 14.6918C5.94165 14.8777 6.11997 15.0217 6.32813 15.1051C6.53596 15.19 6.76453 15.2103 6.9841 15.1636C7.20367 15.1168 7.40409 15.005 7.5593 14.8428L9.33961 12.9964L12.1641 15.4686C12.3678 15.6494 12.6307 15.7494 12.903 15.7499C13.0224 15.7498 13.141 15.731 13.2546 15.6943C13.4402 15.6354 13.6071 15.529 13.7388 15.3855C13.8704 15.242 13.9621 15.0666 14.0048 14.8766L16.8588 2.46081C16.8844 2.34884 16.8789 2.23203 16.8431 2.1229C16.8073 2.01378 16.7425 1.91645 16.6556 1.84136ZM12.3567 4.37261L6.05742 8.88386L2.56992 8.19972L12.3567 4.37261ZM6.75 14.0624V10.7239L8.49305 12.2525L6.75 14.0624ZM12.9045 14.6249L7.09102 9.52722L15.4582 3.53026L12.9045 14.6249Z" fill="#1B62A4" />
                    </svg>
                </div>
                <h3 class="notifications-telegram__title-text">{$_('notificationSettings.telegramSettingsBlockTitle')}</h3>
            </div>
            <p class="notifications-telegram__text">
                {@html $_('notificationSettings.telegramSettingsBlockDescription')}
            </p>
            <!-- Почему-то копирование не срабатывает на телефоне.. -->
            <div on:click={copyPinCode} class="button button_textual button_icon-text notifications-telegram__controls-btn notifications-telegram__controls-btn_secondary notifications-telegram__copy-code">
                <span>{botPinCode}</span>
                <svg class="copy" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.3438 3.5L8.25 3.5C6.59315 3.5 5.25 4.84315 5.25 6.5L5.25 10.25C5.25 11.9069 6.59315 13.25 8.25 13.25L12 13.25C13.6569 13.25 15 11.9069 15 10.25L15 7.46094M11.3438 3.5L15 7.46094M11.3438 3.5L11.3438 5.46094C11.3438 6.56551 12.2392 7.46094 13.3438 7.46094L15 7.46094" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3 9.5L3 10.5C3 13.2614 5.23858 15.5 8 15.5L9 15.5" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg class="copied" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.25 9.75L7.5 12L12.75 6.75" stroke="#57A41B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>

            <p class="notifications-telegram__text">
                {@html $_('notificationSettings.telegramSettingsBlockDescriptionPart2')}
            </p>

            <a href="https://t.me/zengram_instashpion_bot" class="button button_shadow button_gradient button_icon-text notifications-telegram__controls-btn notifications-telegram__controls-btn_main">
                <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.60714 5.75H5.25C4.42157 5.75 3.75 6.42157 3.75 7.25V13.25C3.75 14.0784 4.42157 14.75 5.25 14.75H11.25C12.0784 14.75 12.75 14.0784 12.75 13.25V10.4107M14.25 4.25H11.25M14.25 4.25V7.25M14.25 4.25L6.75 11.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>{@html $_('notificationSettings.telegramSettingsBlockBotName')}</span></a
            >
        </section>
    </div>
{/if}

<style>

</style>